<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col
        cols="12"
        sm="7"
        md="5"
        lg="4"
        class="d-flex align-center justify-center mx-auto"
      >
        <v-card class="pa-3">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="mb-4">
                <v-btn
                  text
                  @click="$router.history.go(-1)"
                  small
                  v-if="$route.name != 'Start'"
                >
                  <v-icon left>mdi-chevron-left</v-icon>back
                </v-btn>
              </div>

              <div class="mb-4">
                <small>{{ brandName }}</small>
              </div>

              <v-list-item-title class="mb-2">
                <h1>{{ titleSubtitle[0] }}</h1>
              </v-list-item-title>

              <v-list-item-subtitle>{{
                titleSubtitle[1]
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <CreatePoll @poll-created="onPollCreated" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CreatePoll } from "@/components/organizer";

export default {
  components: {
    CreatePoll,
  },

  methods: {
    onPollCreated(event) {
      this.$router.push({ name: "Manage", params: { id: event.data[0].id } });
    },
  },

  computed: {
    titleSubtitle() {
      if (this.$route.name == "Start")
        return ["Get started!", "Let's start by creating your first poll..."];
      else return ["Create", "Enter details to create poll..."];
    },

    brandName() {
      return process.env.VUE_APP_BRAND_NAME;
    },
  },
};
</script>
